"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Symbol = void 0;
const IonTypes_1 = require("../IonTypes");
const FromJsConstructor_1 = require("./FromJsConstructor");
const Value_1 = require("./Value");
const _fromJsConstructor = new FromJsConstructor_1.FromJsConstructorBuilder()
    .withPrimitives(FromJsConstructor_1.Primitives.String)
    .withClassesToUnbox(String)
    .build();
// TODO:
//   This extends 'String' because ion-js does not yet have a SymbolToken construct.
//   It is not possible to access the raw Symbol ID via the Reader API, so it cannot be accessed from this class.
/**
 * Represents a symbol[1] value in an Ion stream.
 *
 * [1] http://amzn.github.io/ion-docs/docs/spec.html#symbol
 */
class Symbol extends (0, Value_1.Value)(String, IonTypes_1.IonTypes.SYMBOL, _fromJsConstructor) {
    /**
     * Constructor.
     * @param symbolText    The text to represent as a symbol.
     * @param annotations   An optional array of strings to associate with this symbol.
     */
    constructor(symbolText, annotations = []) {
        super(symbolText);
        this._setAnnotations(annotations);
    }
    stringValue() {
        return this.toString();
    }
    writeTo(writer) {
        writer.setAnnotations(this.getAnnotations());
        writer.writeSymbol(this.stringValue());
    }
    _valueEquals(other, options = {
        epsilon: null,
        ignoreAnnotations: false,
        ignoreTimestampPrecision: false,
        onlyCompareIon: true,
    }) {
        let isSupportedType = false;
        let valueToCompare = null;
        //if the provided value is an ion.dom.Symbol instance.
        if (other instanceof Symbol) {
            isSupportedType = true;
            valueToCompare = other.stringValue();
        }
        else if (!options.onlyCompareIon) {
            // We will consider other Symbol-ish types
            if (typeof other === "string" || other instanceof String) {
                isSupportedType = true;
                valueToCompare = other.valueOf();
            }
        }
        if (!isSupportedType) {
            return false;
        }
        return this.compareValue(valueToCompare) === 0;
    }
    compareValue(expectedValue) {
        return this.stringValue().localeCompare(expectedValue);
    }
}
exports.Symbol = Symbol;
